// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2QAxZ","large":"styles_large__3xyMh"};